import React from "react";
import { Box } from "@mui/material";
import { useDraggable } from "@dnd-kit/core";

interface DraggablePredefinedAnnexItemProps {
  doc: { id?: number };
  children: React.ReactNode;
}

export const DraggablePredefinedAnnexItem: React.FC<
  DraggablePredefinedAnnexItemProps
> = ({ doc, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef: setDragRef,
    isDragging,
  } = useDraggable({
    id: `annex-${doc.id}`,
    data: { doc },
  });

  return (
    <Box
      ref={setDragRef}
      {...attributes}
      {...listeners}
      sx={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "grab",
        borderRadius: 1,
        transition: "opacity 0.2s",
        position: "relative",
      }}
    >
      <Box
        sx={{
          opacity: isDragging ? 0 : 1,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
